import TrustBadge from "../components/oracle-v2/TrustBadge";
import RetentionPolicyInfoModal from "../components/RetentionPolicyInfoModal";

export default function V2Dashboard() {
    return (
        <div style={{
            minHeight: "80vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            fontFamily: "'Inter', sans-serif"
        }}>
            {/* Titre + bouton (i) RCDE */}
            <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: 40 }}>
                <h2 style={{ color: "#00FF94", margin: 0, letterSpacing: 2 }}>VAULT STATUS</h2>
                <RetentionPolicyInfoModal />
            </div>
            <div style={{
                background: "rgba(10, 10, 10, 0.8)",
                padding: "60px",
                borderRadius: "32px",
                border: "1px solid rgba(255,255,255,0.05)",
                backdropFilter: "blur(20px)",
                boxShadow: "0 0 40px rgba(0,0,0,0.4)"
            }}>
                <TrustBadge />
            </div>
            <div style={{ marginTop: 40, opacity: 0.4, fontSize: "0.8rem" }}>
                Continuous Cryptographic Integrity Monitoring Active
            </div>
        </div>
    );
}
